import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import './style.css';
import Header from "./components/header";
import ViewershipTab from "./pages/viewership";
import SubscriptionTab from "./pages/subscription";
import AvodTab from "./pages/avod_performance";
import { useViewershipData, useSubscriptionData, useAvodData, useUsersInfo } from "./data";

const TAB_PATH_MAP = {
  viewership: "/viewership",
  subscription: "/subscription",
  avod: "/avod-performance"
};

const getTabFromPath = (pathname = "") => {
  if (pathname === TAB_PATH_MAP.subscription) return "subscription";
  if (pathname === TAB_PATH_MAP.avod) return "avod";
  return "viewership";
};

const Dashboard = () => {
  const isContentPartner = localStorage.getItem('role_id') == 8;
  const history = useHistory();
  const location = useLocation();
  const usersData = useUsersInfo(localStorage.getItem("pub_id"), isContentPartner);
  const [defaultChannel, setDefaultChannel] = useState(null);
  const activeTab = getTabFromPath(location.pathname);

  function channelFilterColumnConfig() {
    let publisherChannels = JSON.parse(localStorage.getItem("channelConfig") || "[]");
    
    if (publisherChannels.length > 0) {
      const currentChannelId = localStorage.getItem("currentChannel");
      const defaultChannelFromStorage = publisherChannels.find(item => currentChannelId == item.channel_id);
      
      setDefaultChannel(defaultChannelFromStorage || publisherChannels[0]);
    }
  }
  
  useEffect(() => {
    channelFilterColumnConfig();
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      history.replace(TAB_PATH_MAP.viewership);
    }
  }, [location.pathname, history]);

  const handleTabSelect = (key) => {
    const nextTab = key || "viewership";
    const nextPath = TAB_PATH_MAP[nextTab] || TAB_PATH_MAP.viewership;

    if (location.pathname !== nextPath) {
      history.push(nextPath);
    }
  };

  const defaultDateRange = (days = 7) => {
    const today = new Date();
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - (days - 1));
    const endDate = today;
    const previousEndDate = new Date(startDate);
    previousEndDate.setDate(startDate.getDate() - 1);
    const previousStartDate = new Date(startDate);
    previousStartDate.setDate(startDate.getDate() - days);

    return { 
      startDate, 
      endDate, 
      previousStartDate, 
      previousEndDate, 
      key: "rollup", 
      label: "Last 7 Days" 
    };
  };
  const [viewershipDateRange, setViewershipDateRange] = useState([defaultDateRange()]);
  const [subscriptionDateRange, setSubscriptionDateRange] = useState([defaultDateRange()]);
  const [avodDateRange, setAvodDateRange] = useState([defaultDateRange()]);

  const {
    loading: viewershipLoading,
    loadingStates: viewershipLoadingStates,
    viewedMinutesData,
    viewsData,
    activeUsersData,
    newRegistrationsData,
    topShows,
    totalUsers,
    liveViewers,
    activeUsersStats
  } = useViewershipData(
    viewershipDateRange,
    defaultChannel,
    usersData,
    isContentPartner,
    activeTab === "viewership"
  );
  
  const {
    loading: subscriptionLoading,
    // activeSubscribersData,
    activeSubscriptions,
    newSubscribersData,
    totalRevenueData,
    cancellationsData
  } = useSubscriptionData(
    subscriptionDateRange,
    defaultChannel,
    usersData,
    isContentPartner,
    activeTab === "subscription"
  );
  
  const {
    loading: avodLoading,
    avodRevenue,
    avodFillRate,
    avodCPM,
    avodRequests,
    avodImpressions
  } = useAvodData(
    avodDateRange,
    defaultChannel,
    isContentPartner,
    activeTab === "avod"
  );

  return (
    <>
      <Header 
        subtitle={`Hi ${defaultChannel?.channel_name || "User"}`}
        hasSearchBar={true}
      />
      <h1 className="fs-5 pl-2 mb-3 mt-3 mx-2">Analytics</h1>
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        id="dashboard-tabs"
        className="dashboard-tabs pl-4"
      >
        <Tab eventKey="viewership" title="Viewership" className="viewership-tab">
          <ViewershipTab
            viewershipDateRange={viewershipDateRange}
            setViewershipDateRange={setViewershipDateRange}
            viewedMinutesData={viewedMinutesData}
            viewsData={viewsData}
            activeUsersData={activeUsersData}
            newRegistrationsData={newRegistrationsData}
            topShows={topShows}
            totalUsers={totalUsers}
            liveViewers={liveViewers}
            activeUsersStats={activeUsersStats}
            isLoading={viewershipLoading}
            loadingStates={viewershipLoadingStates}
          />
        </Tab>

        <Tab eventKey="subscription" title="Subscription">
          <SubscriptionTab
            subscriptionDateRange={subscriptionDateRange}
            setSubscriptionDateRange={setSubscriptionDateRange}
            activeSubscriptions={activeSubscriptions}
            newSubscribersData={newSubscribersData}
            totalRevenueData={totalRevenueData}
            cancellationsData={cancellationsData}
            isLoading={subscriptionLoading}
          />
        </Tab>
        
        <Tab eventKey="avod" title="AVOD Perfomance">
          <AvodTab
            avodDateRange={avodDateRange}
            setAvodDateRange={setAvodDateRange}
            avodRevenue={avodRevenue}
            avodFillRate={avodFillRate}
            avodCPM={avodCPM}
            avodRequests={avodRequests}
            avodImpressions={avodImpressions}
            isLoading={avodLoading}
          />
        </Tab>

      </Tabs>
    </>
  );
};

export default Dashboard;